export enum TypeBudget {
    REEL = 0,
    PREVISIONNEL = 1
}
